import {computed} from "mobx";
import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";

export class LineupsMemberYardFormationViewModel extends BaseViewModel {
  @computed get line(): Number {
    return this.domainModel.line;
  }

  @computed get fieldPosition(): Number {
    return this.domainModel.fieldPosition;
  }

  @computed get fieldLine(): Number {
    return this.domainModel.fieldLine;
  }

  @computed get fieldSide(): Number {
    return this.domainModel.fieldSide;
  }
}
